module.exports = __webpack_public_path__ + "static/media/Bot_Nova_Nombre2.01eff096.png";